import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { noop } from 'lodash';
import Grid from '../../../webcommon/grid/Grid';
import { ReactComponent as Return } from '../../../webcommon/common/Icons/Return.svg';
import GridHeader from '../../../common/gridheader/GridHeader';
import defaultStyles from './DataDetails.module.scss';
import { webJobsDetailedLoaded, returnToDataLoad } from './actions';
import { getLoading, combinedColumnsSelector, getRows } from './selectors';
import SimpleGridHeaderButton from '../../../common/gridheader/simplegridheader/SimpleGridHeaderButton';

const DataDetails = (props) => {
    const { webJobsDetailedLoaded, location } = props;
    useEffect(() => {
        webJobsDetailedLoaded(location.search);
    }, [webJobsDetailedLoaded, location.search]);

    return (
        <div className={ props.styles.dataDetailsWrapper }>
            <GridHeader
                title="Job Details"
            >
                <SimpleGridHeaderButton
                    onClick={ props.returnToDataLoad }
                    text="Return to Data Load"
                ><Return />

                </SimpleGridHeaderButton>
            </GridHeader>
            <Grid
                columns={ props.columns }
                defaultColumnSpacing={ 2 }
                filterable
                loading={ props.loading }
                rows={ props.rows }
                sortable
            />
        </div>
    );
};

DataDetails.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string
        })
    ),
    loading: PropTypes.bool,
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    returnToDataLoad: PropTypes.func.isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string),
    webJobsDetailedLoaded: PropTypes.func
};

DataDetails.defaultProps = {
    columns: [],
    loading: false,
    styles: defaultStyles,
    rows: [],
    webJobsDetailedLoaded: noop
};

const mapStateToProps = state => ({
    columns: combinedColumnsSelector(state),
    loading: getLoading(state),
    rows: getRows(state)
});

const mapDispatchToProps = {
    returnToDataLoad,
    webJobsDetailedLoaded
};

export default withRouter(connect(mapStateToProps,
    mapDispatchToProps)(DataDetails));

export { DataDetails as WebJobsUnconnected };
